module.exports = __webpack_public_path__ + "img/Fond-tarifs1.a3fa1bf8.jpg";